// File for logic corresponding to weather-current component
import { Component } from 'js-component-framework';
import './weather-current.scss';

/**
 * Component for the current weather module.
 */
export default class WeatherCurrent extends Component { // eslint-disable-line react/prefer-stateless-function
  /**
   * Start the component
   */
  constructor(config) { // eslint-disable-line no-useless-constructor
    super(config);
  }
}
